import React from 'react'
import TopBar from '../components/TopBar'
import SideBar from '../components/SideBar'
import { Outlet } from "react-router-dom";
import { Grid } from '@mui/material';

const Layout = ({ role, heading, userId }) => {
  return (
    <div>

      <TopBar heading={heading} />
      <Grid display={'flex'} flexDirection={'row'}>
        <SideBar role={role} userId={userId} />
        <Grid display={'flex'} justifyContent={'center'} width={'100%'}>
          <Outlet />
        </Grid>

      </Grid>

    </div>
  )
}

export default Layout